import classNames from 'classnames'
import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import ReportCollection from '../../State/Collections/ReportCollection'
import LayoutStore from '../../State/LayoutStore'
import { caseInsensitiveContains } from '../../utils'
import {
    Dropdown3,
    Dropdown3ListItem,
    SmallDeleteButton,
    FilterTextBox,
} from '../../widgets'
import { operatorLabels } from '../Filters'
import Inputs from '../Inputs'
import {
    CostCentreMultiselect,
    MultiSelect,
    ProjectMultiselect,
    RoleMultiselect,
    StaffMultiselect,
    StatusMultiselect,
} from '../MultiSelect'
import pluralize from 'pluralize'
import RenameReportModal from './RenameReportModal'
import DataStore from '../../State/DataStore'
import SaveAsReportModal from './SaveAsReportModal'
import SortableMultiselect from '../Widgets/SortableMultiselect'
import Checkbox from '../Widgets/Checkbox'
import { capitalCase } from 'change-case'
import CostCentreCollection from '../../State/Collections/CostCentreCollection'
import ProjectCollection from '../../State/Collections/ProjectCollection'
import StaffCollection from '../../State/Collections/StaffCollection'
import RoleCollection from '../../State/Collections/RoleCollection'
import { Selector } from '../Selector'
import AddStaffModal from '../../Pages/ResourceSchedulePage/AddStaffModal'
import HeaderButton from '../ui/HeaderButton'
import { useNavigate } from '@tanstack/react-router'
import _ from 'lodash'

export default observer(({ store, report, reportOptions = [] }) => {
    const [expandReportEditor, setExpandReportEditor] = useState(false)
    const navigate = useNavigate()
    return (
        <>
            <div className="report-selector flex items-center gap-2 mt-7">
                {'Report: '}
                <Selector
                    className="flex-0-0-auto page-header__button"
                    style={{ marginLeft: '1em' }}
                    value={report}
                    options={reportOptions}
                    searchMatcher={function (report, searchText) {
                        return caseInsensitiveContains(report.name, searchText)
                    }}
                    optionLabel={function (report) {
                        return <div>{report.name}</div>
                    }}
                    onChange={(report) =>
                        navigate({
                            search: (prev) => ({
                                ...prev,
                                report: report.id,
                            }),
                        })
                    }
                />
                <div className="flex items-center gap-2">
                    <div className="flex">
                        <button
                            className={classNames(
                                'py-2 px-4 border border-white text-xs',
                                store.periodType === 'month'
                                    ? 'bg-white text-black'
                                    : 'text-white bg-transparent'
                            )}
                            style={{
                                margin: 0,
                                borderRadius: '0.5rem 0 0 0.5rem',
                            }}
                            onClick={() => store.setPeriodType('month')}
                        >
                            Monthly
                        </button>
                        <button
                            className={classNames(
                                'py-2 px-4 border border-white text-xs',
                                store.periodType === 'week'
                                    ? 'bg-white text-black'
                                    : 'text-white bg-transparent'
                            )}
                            style={{
                                margin: 0,
                                borderRadius: '0 0.5rem 0.5rem 0',
                            }}
                            onClick={() => store.setPeriodType('week')}
                        >
                            Weekly
                        </button>
                    </div>
                    <HeaderButton
                        label={expandReportEditor ? 'Hide ' : 'Edit '}
                        icon={
                            <i
                                className={classNames(
                                    'fa m-0',
                                    expandReportEditor
                                        ? 'fa-angle-double-up'
                                        : 'fa-angle-double-down'
                                )}
                            />
                        }
                        onClick={() =>
                            setExpandReportEditor(!expandReportEditor)
                        }
                    />
                    {expandReportEditor ? (
                        <span>
                            <ReportSaveDropdown report={report} />
                            {!report.systemReport ? (
                                <ReportActionsDropdown report={report} />
                            ) : null}
                        </span>
                    ) : null}
                    <HeaderButton
                        label="+ Add Resource"
                        onClick={() => {
                            LayoutStore.openModal(
                                <AddStaffModal
                                    modalId={'add-staff-to-resources'}
                                    report={report}
                                />
                            )
                        }}
                    />
                </div>
            </div>
            {expandReportEditor ? (
                <ReportEditor report={report} store={store} />
            ) : null}
        </>
    )
})

const ReportSaveDropdown = observer(({ report }) => {
    return (
        <Dropdown3
            // isExpanded={this.props.isExpanded}
            // onToggle={this.handleToggle}
            toggleElement={
                <button className="primary flex items-center gap-1 py-2 px-4 border border-white bg-transparent hover:bg-white/25 transition-colors rounded-[6px] text-xs">
                    Save
                    <i className="rw-i rw-i-caret-down" />
                </button>
            }
            contentStyle={{
                width: '14em',
                color: '#444',
                borderRadius: '0.5em',
            }}
        >
            {!report.systemReport ? (
                <Dropdown3ListItem
                    style={{ padding: '0.5em 1em', height: '2.5em' }}
                    className="report-save-dropdown__save-option"
                    onClick={() => DataStore.saveModel(report)}
                >
                    Save
                </Dropdown3ListItem>
            ) : null}
            <Dropdown3ListItem
                style={{ padding: '0.5em 1em', height: '2.5em' }}
                onClick={() => {
                    LayoutStore.openModal(
                        <SaveAsReportModal
                            report={report}
                            modalId={'saveAsReport'}
                        />
                    )
                }}
            >
                Save As...
            </Dropdown3ListItem>
        </Dropdown3>
    )
})

const ReportActionsDropdown = observer(({ report }) => {
    const navigate = useNavigate()
    return (
        <Dropdown3
            // isExpanded={this.props.isExpanded}
            // onToggle={this.handleToggle}
            toggleElement={
                <button className="primary flex items-center gap-1 ml-2 py-2 px-4 border border-white bg-transparent hover:bg-white/25 transition-colors rounded-[6px] text-xs">
                    Actions
                    <i
                        className="rw-i rw-i-caret-down"
                        style={{ marginLeft: '0.5em' }}
                    />
                </button>
            }
            contentStyle={{
                width: '18em',
                color: '#444',
                borderRadius: '0.5em',
            }}
        >
            <Dropdown3ListItem
                style={{ padding: '0.5em 1em', height: '2.5em' }}
                onClick={() => {
                    report.makeDefault()
                    DataStore.saveModel(report)
                }}
            >
                Set As Default
            </Dropdown3ListItem>
            <Dropdown3ListItem
                style={{ padding: '0.5em 1em', height: '2.5em' }}
                onClick={() => {
                    LayoutStore.openModal(
                        <RenameReportModal
                            report={report}
                            modalId={'renameReport'}
                        />
                    )
                }}
            >
                Rename
            </Dropdown3ListItem>
            <Dropdown3ListItem
                style={{ padding: '0.5em 1em', height: '2.5em' }}
                onClick={() => {
                    report.update({ deletedAt: new Date() })
                    DataStore.saveModel(report)
                    navigate({
                        search: (prev) =>
                            _.omitBy(
                                {
                                    ...prev,
                                    report: null,
                                },
                                (v) => v === null
                            ),
                    })
                }}
            >
                Delete
            </Dropdown3ListItem>
        </Dropdown3>
    )
})

const ReportEditor = observer(({ report, store }) => {
    return (
        <div
            className="dont-print py-6 border-t border-[#666]"
            // style={{
            //     backgroundColor: 'rgba(255, 255, 255, 0.1)',
            //     borderRadius: '1em',
            //     margin: '1em 0',
            // }}
        >
            <ReportFilterList
                store={store}
                report={report}
                filters={report.filters}
            />
        </div>
    )
})

const ReportFilterList = observer(({ columns, filters, store, report }) => {
    return (
        <div className="report-selector w-full bg-white/10 rounded-[6px] py-2">
            <div style={{ padding: '1em 0.5em' }}>
                Groups:
                <MultiSelect
                    selectedOptions={filters.groups?.map((g) => ({
                        value: g,
                        label: capitalCase(g),
                    }))}
                    options={[
                        { value: 'status', label: 'Status' },
                        { value: 'owner', label: 'Owner' },
                        { value: 'role', label: 'Role' },
                        { value: 'staff', label: 'Staff' },
                        { value: 'project', label: 'Project' },
                        { value: 'phase', label: 'Phase' },
                    ]}
                    style={{ width: '50em' }}
                    onChange={(groups) => {
                        return store.updateFilters({
                            groups: groups.map((g) => g.value),
                        })
                    }}
                    onBlur={() => null}
                    filter={function (item, searchText) {
                        return String(item)
                            .toLowerCase()
                            .match(searchText.toLowerCase())
                    }}
                    styles={{
                        container: (provided, state) => ({
                            ...provided,
                            color: '#444',
                            width: '50em',
                        }),
                        input: (provided, state) => ({
                            ...provided,
                            color: '#444',
                        }),
                        menu: (provided, state) => ({
                            ...provided,
                            fontSize: '0.9em',
                            color: '#444',
                        }),
                    }}
                />
            </div>
            <div className='"py-[1em] px-[0.5em] flex items-end flex-wrap"'>
                <div style={{ marginRight: '2em' }}>
                    {'Hours Data: '}
                    <Selector
                        className="flex-0-0-auto page-header__button"
                        style={{ margin: '0 1.5em 0 0.5em', maxWidth: '15em' }}
                        value={filters.hoursData}
                        onChange={(hoursData) =>
                            store.updateFilters({ hoursData })
                        }
                        options={[
                            {
                                label: 'Actuals + Projected',
                                value: 'actualsProjected',
                            },
                            { label: 'Actuals', value: 'actuals' },
                            { label: 'Projected', value: 'projected' },
                            {
                                label: 'Actuals / Projected',
                                value: 'actualsVsProjected',
                            },
                            {
                                label: 'Remaining Projected Monthly',
                                value: 'remainingProjected',
                            },
                            {
                                label: 'Remaining Projected Monthly (Capped)',
                                value: 'remainingProjectedCapped',
                            },
                        ]}
                    />
                </div>
                <div style={{ marginRight: '2em' }}>
                    {'Totals: '}
                    <Selector
                        className="flex-0-0-auto page-header__button"
                        style={{ margin: '0 1.5em 0 0.5em' }}
                        value={filters.totalData}
                        onChange={(totalData) =>
                            store.updateFilters({ totalData })
                        }
                        options={[
                            { label: 'Budget Use', value: 'budgetUse' },
                            {
                                label: 'Remaining Budget',
                                value: 'remainingBudget',
                            },
                            {
                                label: 'Average Utilisation',
                                value: 'averageUtilisation',
                            },
                        ]}
                    />
                </div>
                <div style={{ marginRight: '2em' }}>
                    {'Percent: '}
                    <Selector
                        className="flex-0-0-auto page-header__button"
                        style={{ margin: '0 1.5em 0 0.5em' }}
                        value={filters.percentData}
                        onChange={(percentData) =>
                            store.updateFilters({ percentData })
                        }
                        options={[
                            { label: 'Utilisation', value: 'utilisation' },
                            { label: 'Budget Use', value: 'budgetUse' },
                            {
                                label: 'Monthly Budget Use',
                                value: 'monthlyBudgetUse',
                            },
                            {
                                label: 'Remaining Monthly Budget Use',
                                value: 'remainingMonthlyBudgetUse',
                            },
                            {
                                label: 'Remaining Monthly Budget Use (Capped)',
                                value: 'remainingMonthlyBudgetUseCapped',
                            },
                        ]}
                    />
                </div>
                <div style={{ marginRight: '2em' }}>
                    <Checkbox
                        value={filters.futureRows}
                        onChange={(futureRows) =>
                            store.updateFilters({ futureRows })
                        }
                    />
                    {' Only show Projects with future work allocated.'}
                </div>
                <div style={{ marginRight: '2em' }}>
                    <Checkbox
                        value={filters.activePhases}
                        onChange={(activePhases) =>
                            store.updateFilters({ activePhases })
                        }
                    />
                    {' Include All Active Phases.'}
                </div>
            </div>
            <div className="flex" style={{ width: '100%', fontSize: '0.95em' }}>
                <div style={{ width: '20%', padding: '0.5em' }}>
                    Cost Centres:
                    <CostCentreMultiselect
                        selectedCostCentres={filters?.costCentres.map(
                            (cId) => CostCentreCollection.costCentresById[cId]
                        )}
                        onChange={(costCentres) =>
                            store.updateFilters({
                                costCentres: costCentres.map((cc) => cc.id),
                            })
                        }
                        onBlur={() => null}
                        styles={{
                            container: (provided, state) => ({
                                ...provided,
                                color: '#444',
                            }),
                            input: (provided, state) => ({
                                ...provided,
                                color: '#444',
                            }),
                            menu: (provided, state) => ({
                                ...provided,
                                fontSize: '0.9em',
                                color: '#444',
                            }),
                        }}
                    />
                </div>
                <div style={{ width: '20%', padding: '0.5em' }}>
                    Status:
                    <StatusMultiselect
                        selectedStatuses={filters.projectStatus}
                        onChange={(projectStatuses) => {
                            return store.updateFilters({
                                projectStatus: projectStatuses,
                            })
                        }}
                        onBlur={() => null}
                        styles={{
                            container: (provided, state) => ({
                                ...provided,
                                color: '#444',
                            }),
                            input: (provided, state) => ({
                                ...provided,
                                color: '#444',
                            }),
                            menu: (provided, state) => ({
                                ...provided,
                                fontSize: '0.9em',
                                color: '#444',
                            }),
                        }}
                    />
                </div>
                <div style={{ width: '20%', padding: '0.5em' }}>
                    Projects:
                    <ProjectMultiselect
                        selectedProjects={filters.projects?.map(
                            (cId) => ProjectCollection.projectsById[cId]
                        )}
                        onChange={(projects) =>
                            store.updateFilters({
                                projects: projects.map((p) => p.id),
                            })
                        }
                        onBlur={() => null}
                        styles={{
                            container: (provided, state) => ({
                                ...provided,
                                color: '#444',
                            }),
                            input: (provided, state) => ({
                                ...provided,
                                color: '#444',
                            }),
                            menu: (provided, state) => ({
                                ...provided,
                                fontSize: '0.9em',
                                color: '#444',
                            }),
                        }}
                    />
                </div>
                <div style={{ width: '20%', padding: '0.5em' }}>
                    Roles:
                    <RoleMultiselect
                        selectedRoles={filters.roles?.map(
                            (cId) => RoleCollection.rolesById[cId]
                        )}
                        onChange={(roles) => {
                            return store.updateFilters({
                                roles: roles.map((r) => r.id),
                            })
                        }}
                        onBlur={() => null}
                        styles={{
                            container: (provided, state) => ({
                                ...provided,
                                color: '#444',
                            }),
                            input: (provided, state) => ({
                                ...provided,
                                color: '#444',
                            }),
                            menu: (provided, state) => ({
                                ...provided,
                                fontSize: '0.9em',
                                color: '#444',
                            }),
                        }}
                    />
                </div>
                <div style={{ width: '20%', padding: '0.5em' }}>
                    Staff:
                    <StaffMultiselect
                        selectedStaffMembers={filters.staff?.map(
                            (cId) => StaffCollection.staffsById[cId]
                        )}
                        onChange={(staff) =>
                            store.updateFilters({
                                staff: staff.map((st) => st.id),
                            })
                        }
                        onBlur={() => null}
                        styles={{
                            container: (provided, state) => ({
                                ...provided,
                                color: '#444',
                            }),
                            input: (provided, state) => ({
                                ...provided,
                                color: '#444',
                            }),
                            menu: (provided, state) => ({
                                ...provided,
                                fontSize: '0.9em',
                                color: '#444',
                            }),
                        }}
                    />
                </div>
                <div style={{ width: '20%', padding: '0.5em' }}>
                    Project Owner:
                    <StaffMultiselect
                        selectedStaffMembers={filters.projectOwners?.map(
                            (cId) => StaffCollection.staffsById[cId]
                        )}
                        onChange={(staff) =>
                            store.updateFilters({
                                projectOwners: staff.map((st) => st.id),
                            })
                        }
                        onBlur={() => null}
                        styles={{
                            container: (provided, state) => ({
                                ...provided,
                                color: '#444',
                            }),
                            input: (provided, state) => ({
                                ...provided,
                                color: '#444',
                            }),
                            menu: (provided, state) => ({
                                ...provided,
                                fontSize: '0.9em',
                                color: '#444',
                            }),
                        }}
                    />
                </div>
            </div>
        </div>
    )
})

export const ReportSearch = observer(({ report, placeholder }) => {
    return (
        <FilterTextBox
            style={{ width: '19em' }}
            value={report.searchFilter || ''}
            onChange={(val) => report.updateSearchFilter(val)}
            placeholder={placeholder}
        />
    )
})
